import { z } from 'zod'
import { phoneOrEmpty } from '@/lib/phone'

const phoneField = phoneOrEmpty('deals.createDialog.validation.phoneInvalid')

const emailField = z
	.string()
	.trim()
	.refine(
		(v) => v === '' || z.string().email().safeParse(v).success,
		'deals.createDialog.validation.emailInvalid',
	)

export const createDealSchema = z
	.object({
		propertyId:  z.string().min(1, 'deals.createDialog.validation.propertyRequired'),
		clientName:  z.string().trim().min(1, 'deals.createDialog.validation.clientNameRequired'),
		clientPhone: phoneField,
		clientEmail: emailField,
	})
	// One field used to hold either a phone or an email, and the submit handler
	// guessed between them by looking for an "@" — so "asdf" was stored as a
	// phone number. Two fields remove the guess, but a contact still needs at
	// least one way to be reached, hence the pair requirement rather than
	// making each field mandatory.
	.superRefine((values, ctx) => {
		if (values.clientPhone === '' && values.clientEmail === '') {
			for (const path of ['clientPhone', 'clientEmail'] as const) {
				ctx.addIssue({
					code:    z.ZodIssueCode.custom,
					path:    [path],
					message: 'deals.createDialog.validation.contactRequired',
				})
			}
		}
	})

export type CreateDealFormValues = z.infer<typeof createDealSchema>

export const DEFAULT_VALUES: CreateDealFormValues = {
	propertyId:  '',
	clientName:  '',
	clientPhone: '',
	clientEmail: '',
}
